export interface RowData<T> {
    header: string;
    accessor: string; // format: "{parent}: ... :{child}"
    rowAccessor?: (row: T) => any; // (optional) used to access row data w/ finer control
    flex?: number;
    minCellWidth?: number; // px <- initial size
    columnWidth?: number; // px <- adjusted column width
    contentWidth?: number; // px <- adjusted content width
    isShown?: boolean; // enables user to select which columns to show
}
export interface TableDefinition<T = any> {
    rowTemplate: RowData<T>[];
    defaultSortKey: string; // we use this format so it's the same as accessors
}

export interface SortObject {
    sortKey: string; // same format as RowData's accessor
    reversed: boolean;
}

export enum ItemSelectBehavior {
    Checkbox = "Checkbox",
    Radio = "Radio",
    Range = "Range",
}
